// @ts-nocheck — звичайний JavaScript для браузера, без типів TypeScript
/* Предмети для редактора рамок (вкладка «Предмети»).
   Кладуться на фон у справжньому розмірі, не масштабуються,
   але отримують рядок у вкладці «Підписи» — як звичайна фігурка.

   Кожен запис:
     id     — унікальний, латиницею, без пробілів (не міняти після запуску)
     name   — те, що бачить клієнт, і назва в розрахунку ціни
     url    — посилання на PNG з прозорим фоном
     price  — скільки додає до вартості рамки (грн)
     spritePx — true: файл різаний «в обріз», його власні пікселі вже є
              пікселями спрайта фігурки. Розмір беремо просто з картинки
     scale  — необовʼязково: 1 = як намальовано, 0.8 = менший, 1.2 = більший
     soon   — true: предмет видно, але обрати поки не можна

   ВАЖЛИВО про розмір. Полотно кожного файлу — 2500×3084, тобто рівно таке,
   як у спрайтів фігурок. Саме тому предмет лягає у справжньому розмірі
   відносно фігурки: редактор бере пропорцію з полотна, а не з самої картинки.
   Якщо колись домалюєш новий предмет — тримайся того ж полотна, і scale
   не знадобиться взагалі.

   Файли можна різати і «в обріз», без великого полотна: тоді редактор бере
   пропорцію з самої картинки, а висота предмета дорівнює зросту фігурки.
*/
window.FE_ITEM_LIB = [

  // ── Діти ─────────────────────────────────────────────────────────
  { id:'dytyna-1', name:'1',
    url:'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/Predm_1.png?v=1787351612' },
  { id:'dytyna-2', name:'2',
    url:'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/Predm_2.png?v=1787351618' },
  { id:'dytyna-3', name:'3',
    url:'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/Predm_3.png?v=1787351637' },
  { id:'dytyna-4', name:'4',
    url:'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/Predm_4.png?v=1787351640' },
  { id:'dytyna-5', name:'5',
    url:'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/Predm_5.png?v=1787351641' },

  // ── Немовлята ────────────────────────────────────────────────────
  { id:'nemovlya-1', name:'6',
    url:'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/Predm_6.png?v=1787351644' },
  { id:'nemovlya-2', name:'7',
    url:'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/Predm_7.png?v=1787351646' },
  { id:'nemovlya-3', name:'8',
    url:'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/Predm_8.png?v=1787351648' },
  { id:'nemovlya-4', name:'9',
    url:'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/Predm_9.png?v=1787351650' },

  // ── Транспорт ────────────────────────────────────────────────────
  // Ці два намальовані «в обріз», без великого полотна: 543×330 і 455×286 —
  // це вже готовий розмір поруч із фігуркою. Ознака spritePx каже редактору
  // не перераховувати нічого. Якщо треба трохи більше чи менше — scale.
  { id:'moped',     name:'10', soon:true, spritePx:true,   // скутер, 543×330
    url:'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/skuter_10.png?v=1787752732' },
  { id:'velosyped', name:'11', soon:true, spritePx:true,   // велосипед, 455×286
    url:'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/volosepid_11.png?v=1787752721' },

];
